import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getCropsForProductByTypeAndTrialsCountry } from 'api/CropNutritionPrograms';
import { getTrialResults, getTrialResultsDetail } from 'api/TrialResults';
import { fetchWithLanguage } from 'store/helpers';

export const fetchTrialResults = fetchWithLanguage('fetchTrialResults', getTrialResults);
export const fetchTrialResultsDetail = fetchWithLanguage('fetchTrialResultsDetail', getTrialResultsDetail);
export const fetchTrialResultsForProductForCurrentCountry = fetchWithLanguage(
    'fetchTrialResultsForProductForCurrentCountry',
    getCropsForProductByTypeAndTrialsCountry,
);
export const fetchTrialResultsForProductForOthers = fetchWithLanguage(
    'fetchTrialResultsForProductForOthers',
    getCropsForProductByTypeAndTrialsCountry,
);

const trialResultsSlice = createSlice({
    name: 'trialResultsSlice',
    initialState: {
        trialResults: {},
        trialResultsDetail: {},
        TrialResultsForProductForCurrentCountry: {
            data: [],
            next: false,
        },
        TrialResultsForProductForOthers: {
            data: [],
            next: false,
        },
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchTrialResults.fulfilled, (state, action) => {
                state.trialResults = action.payload;
            })
            .addCase(fetchTrialResultsDetail.fulfilled, (state, action) => {
                state.trialResultsDetail = action.payload;
            })
            .addCase(fetchTrialResultsForProductForCurrentCountry.fulfilled, (state, action) => {
                const { payload } = action;
                state.TrialResultsForProductForCurrentCountry.next = payload.next;
                state.TrialResultsForProductForCurrentCountry.data.push(...payload.data);
            })
            .addCase(fetchTrialResultsForProductForOthers.fulfilled, (state, action) => {
                const { payload } = action;
                state.TrialResultsForProductForOthers.next = payload.next;
                state.TrialResultsForProductForOthers.data.push(...payload.data);
            });
    },
});

export const selectTrialResultsPage = createSelector(
    [state => state.trialResultsState.trialResults],
    trialResults => trialResults.data || {},
);
export const selectTrialResultsDetail = createSelector(
    [state => state.trialResultsState.trialResultsDetail],
    trialResultsDetail => trialResultsDetail.data || {},
);
export const selectTrialResultsForProductForCurrentCountry = createSelector(
    [state => state.trialResultsState.TrialResultsForProductForCurrentCountry],
    TrialResultsForProductForCurrentCountry => TrialResultsForProductForCurrentCountry || {},
);
export const selectTrialResultsForProductForOthers = createSelector(
    [state => state.trialResultsState.TrialResultsForProductForOthers],
    TrialResultsForProductForOthers => TrialResultsForProductForOthers || {},
);

export default trialResultsSlice.reducer;
